import { useEffect } from 'react';

type CheckoutOrderRecalculation = () => Promise<void>;

let registeredRecalculation: CheckoutOrderRecalculation | undefined;

export const useRegisterCheckoutOrderRecalculation = (
	recalculation: CheckoutOrderRecalculation
) => {
	useEffect(() => {
		registeredRecalculation = recalculation;
		return () => {
			// Guard against clearing a newer registration during the overlap of a remount.
			if (registeredRecalculation === recalculation) {
				registeredRecalculation = undefined;
			}
		};
	}, [recalculation]);
};

export const runCheckoutOrderRecalculation = async (): Promise<boolean> => {
	if (!registeredRecalculation) {
		return false;
	}
	await registeredRecalculation();
	return true;
};
